<mat-list class="date" cdk-focus-region-start>
  @if (doc && doc.write && !edit) {
    <button style="    float: right;" (click)="edit = !edit" mat-fab color="primary">
      <mat-icon style="    color: white;" >edit</mat-icon>
    </button>
  }
  @if (doc && doc.write && edit) {
    <button style="    float: right;" (click)="saveDoc()" mat-fab color="primary">
      <mat-icon style="    color: white;">save</mat-icon>
    </button>
  }

  @if (doc && doc.write  && !edit) {
    <h2 style="text-align: center;">{{title}}</h2>
  }

  @if (doc &&  !doc.write  && active) {
    <h2 style="text-align: center;" >{{title}}</h2>
  }

  @if (doc && doc.write && edit) {
    <div>
      <mat-form-field class="example-full-width">
        <input matInput placeholder="Title" [(ngModel)]="title">
      </mat-form-field>
      <mat-checkbox [(ngModel)]="active" >Active</mat-checkbox>
      <quill-editor [(ngModel)]="editorContent">
      </quill-editor>
    </div>
  }

  @if (doc && doc.write && !edit && active) {
    <div  class="ql-editor preview" [innerHTML]="htmlSat"></div>
  }
  @if (doc && !doc.write && active) {
    <div  class="ql-editor preview" [innerHTML]="htmlSat"></div>
  }

  @if ((!doc || !active) && !edit) {
    <h2 style="text-align: center;     margin-top: 45%;">No information</h2>
  }
</mat-list>

